import { CreateInventoryContainerComponent } from './create-inventory-container.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Injectable, inject } from '@angular/core';
import { Inventory } from '../inventory.model';

@Injectable({providedIn: 'root'})
export class CreateInventoryDialogService {
  private dialog = inject(MatDialog);


  public openCreateInventoryDialog(predefinedInventoryData: Inventory | null = null): MatDialogRef<CreateInventoryContainerComponent> {
    const config: MatDialogConfig = {
      panelClass: ['dialog-w-900'],
      disableClose: true,
      data: predefinedInventoryData,
      autoFocus: false
    };
    return this.dialog.open(CreateInventoryContainerComponent, config);
  }
}
